import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { CreateGroupDto, GroupDto, GroupsApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useCreateGroup = (
  groupsApi: GroupsApi,
  tenantId: string,
  onError: (err: ErrorResponse) => void,
  onSuccess: ({
    data: { name },
  }: {
    data: {
      name: string;
    };
  }) => void,
): UseMutationResult<AxiosResponse<GroupDto>, ErrorResponse, CreateGroupDto> =>
  useMutation((createGroupDto: CreateGroupDto) => groupsApi.createGroup(tenantId, createGroupDto), {
    onSuccess,
    onError,
  });
